module.exports = __webpack_public_path__ + "3cc3fb1453126b28cda6418a225dbbf4.png";